<template>
  <div class="container">
    <div>
      <el-form :model="queryParams" ref="queryForm"  :inline="true">
    <!-- 查询条件 -->
          <el-row :gutter="10">   
            <el-col :span="5">
              <div>
                  <el-form-item :label="$t('form.startTime')" prop="startTime" >
                    <el-date-picker style="width: 100%;" clearable size="small" v-model="queryParams.startTime" type="date"
                      value-format="yyyy-MM-dd" :placeholder="$t('taskDeliveryPlaceholder.selectStartTime')" :picker-options="startNoTime">
                    </el-date-picker>
                  </el-form-item>
                </div>   
            </el-col>
            <el-col :span="7">
              <el-form-item :label="$t('form.BusinessType')" prop="radio">
                <el-radio v-model="queryParams.flag" style="display: inline-block;" :label="$t('radio.shipment')">{{ $t('radio.shipment') }}</el-radio>
                <el-radio v-model="queryParams.flag" style="display: inline-block;" :label="$t('radio.delivery')">{{ $t('radio.delivery') }}</el-radio>
                <el-radio v-model="queryParams.flag" style="display: inline-block;" :label="$t('radio.total')">{{ $t('radio.total') }}</el-radio>
              </el-form-item>
            </el-col>
            
            <el-col :span="6">
              <el-form-item :label="$t('form.VehicleLicense')">
                <el-input clearable v-model.trim="queryParams.truckNo" :placeholder="$t('taskDeliveryPlaceholder.licensePlate')" 
                  style="width: 118%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" style="display: flex;flex-wrap: nowrap;">
              <el-button type="primary" @click="submit" style="flex-wrap: nowrap; ">{{$t('button.search')}}</el-button>            
              <el-button @click="reset" style="flex-wrap: nowrap; ">{{$t('button.reset')}}</el-button>            
              <el-button type="success" @click="dialogVisible = true" style="flex-wrap: nowrap; ">{{$t('button.add')}}</el-button>
              
            </el-col>
          </el-row>


          <el-row>
            <el-col :span="5">
              <div>
                  <el-form-item :label="$t('form.endTime')" prop="endTime">
                    <el-date-picker style="width: 100%;" clearable size="small" v-model="queryParams.endTime" type="date"
                      value-format="yyyy-MM-dd" :placeholder="$t('taskDeliveryPlaceholder.SelectEndtime')" :picker-options="endNoTime">
                    </el-date-picker>
                  </el-form-item>
                </div>
            </el-col>
            <el-col :span="7">
              <el-form-item :label="$t('form.DeliveryOrder')">
              <el-input clearable v-model.trim="queryParams.blNo" :placeholder="$t('taskDeliveryPlaceholder.deliveryOrder')" @keyup.enter.native="submit"  style="width: 100%;"></el-input>
            </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('form.DriverName')">
                <el-input clearable v-model.trim="queryParams.truckMan" :placeholder="$t('taskDeliveryPlaceholder.drivername')"
                  style="width: 118%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button type="warning" @click="merge" style="flex-wrap: nowrap; ">{{$t('button.MergeIssue')}}</el-button>
              <!-- <el-button type="warning" @click="merge" style="flex-wrap: nowrap; ">{{$t('button.MergeIssue')}}</el-button> -->
            </el-col>
          </el-row>
        </el-form>
    </div>    
  

    <!-- 表格 -->
    <div style="display: flex; overflow-x: auto; " >
      <el-table border highlight-current-row :data="list" height="calc(100vh - 200px)" cell-style="rowStyle" id="tableId"
        ref="tableId" style="overflow-x: hidden; font-size: calc(16.5vw * 100 / 1920); 
       flex-wrap: nowrap; width:calc(100vw - 0px);  " @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center"  min-width="70">
        </el-table-column>
        <el-table-column ref="filterTable" :label="$t('taskDeliverycolumns.Serial')"  type="index"  align="center" min-width="80">
        </el-table-column>
        <!-- <el-table-column label="任务单号" width="auto" align="center">
          <template slot-scope="scope">
            <i class="iconfont icon-OddNumbersdanhao"></i>
            <span style="margin-left: 10px">{{ scope.row.taskNo }}</span>
          </template>
</el-table-column>-->
        <!-- <div> -->
        <el-table-column :label="$t('taskDeliverycolumns.DeliveryOrder')" align="center" min-width="150">
          <template slot-scope="scope">
            <!-- <i class="iconfont icon-xiugaihuizongdanhao"></i> -->
            <span v-copy.dblclick>{{ scope.row.deliveryNo }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="创建人" width="auto" align="center">
          <template slot-scope="scope">
            <i class="iconfont icon-yonghu"></i>
            <span style="margin-left: 10px">{{ scope.row.createMan }}</span>
          </template>
        </el-table-column> -->
        <el-table-column :label="$t('taskDeliverycolumns.WaybillNumber')" align="center"  min-width="150">
          <template slot-scope="scope">
            <!-- <i class="iconfont icon-danjuhao"></i> -->
            <span v-copy.dblclick>{{ scope.row.lmsTaskNo }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('taskDeliverycolumns.LicensePlate')" align="center" min-width="150">
          <template slot-scope="scope">
            <!-- <i class="iconfont icon-chepaihao"></i> -->
            <span v-copy.dblclick>{{ scope.row.truckNo }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('taskDeliverycolumns.DriverName')" align="center"  min-width="80">
          <template slot-scope="scope">
            <!-- <i class="iconfont icon-xingming1"></i> -->
            <span v-copy.dblclick>{{ scope.row.truckMan }}</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true"  :label="$t('taskDeliverycolumns.Remarks')" align="center" min-width="230">
          <template slot-scope="scope">
            <!-- <i class="iconfont icon-beizhu"></i> -->
            <span v-copy.dblclick>{{ scope.row.note }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('taskDeliverycolumns.WarehouseOrder')" align="center" min-width="150">
          <template slot-scope="scope">
            <!-- <i class="iconfont icon-beizhu"></i> -->
            <span style="white-space: nowrap;" v-copy.dblclick> {{ scope.row.wmsNo }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('taskDeliverycolumns.CreationTime')" align="center"  min-width="150">
          <template slot-scope="scope">
            <!-- <i class="el-icon-time"></i> -->
            <span style="white-space: nowrap;" v-copy.dblclick>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('taskDeliverycolumns.BusinessType')" align="center" 
        min-width="85">
          <template slot-scope="scope">
            <!-- <i class="iconfont icon-xitongzhuangtai"></i> -->
            <el-tag style="margin-left: 3px" :type="scope.row.div === '发货' ? 'primary' : 'success'"
              disable-transitions v-copy.dblclick>{{ scope.row.div }}</el-tag>
            <!-- <span style="margin-left: 10px">{{ scope.row.div}}</span> -->
          </template>
        </el-table-column>
        <el-table-column :label="$t('taskDeliverycolumns.Status')" align="center"  min-width="80">
          <template slot-scope="scope">
            <!-- <i class="iconfont icon-xitongzhuangtai"></i> -->
            <span v-copy.dblclick>{{ computedStatus(scope.row.taskFlag) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('taskDeliverycolumns.Operation')" align="center"  min-width="360">
          <template slot-scope="scope">
            <div class="btncl" style="display: flex; flex-direction: row; 
            flex-wrap: nowrap; ">
              <el-button
                type="primary" size="mini" :disabled="disabled(scope.row.taskFlag)"
                @click="handleSend(scope.$index, scope.row)">{{$t('button.issue')}}</el-button>
              <!-- <el-button type="warning" size="small" 
            :disabled="disabled1(scope.row.taskFlag)" 
            @click="handleStop(scope.$index, scope.row)">终止</el-button> -->
              <el-button  type="success" size="mini" :disabled="disabled1(scope.row.taskFlag)"
                @click="handleSign(scope.$index, scope.row)">{{$t('button.signFor')}}</el-button>
              <el-button type="danger" size="mini"
                @click="handleDelete(scope.$index, scope.row)">{{$t('button.delete')}}</el-button>
              <el-button  type="info" size="mini"
                @click="handleDetail(scope.$index, scope.row)">{{$t('button.details')}}</el-button>
              <el-button style="background-color: purple; color: white; border:0;" size="mini"
                @click="handleBatch(scope.$index, scope.row)"
                :disabled="disabled2(scope.$index, scope.row)">{{$t('button.point')}}</el-button>
              <el-button  type="warning" size="mini"
                @click="photo(scope.$index, scope.row)">{{$t('button.photos')}}</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="overflow: hidden;">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[21, 50, 100]" :page-size="21" style="padding: 10px;" layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>

    <!-- 弹出层 -->
    <el-dialog :before-close="handleClose" id="dialog1-id" title="查询任务" :visible.sync="dialogVisible"
      :close-on-click-modal="false" width="70%">
      <el-form style="display: flex; justify-content: space-around ; margin-left: -10%; " :model="ruleForm"
        ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <div style="width: 50%; height: 8%;">
          <el-form-item label="交货单号" prop="vbeln" :rules="[
          { required: true, message: '交货单号不能为空' },
        ]" :label-width="formLabelWidth1">
            <el-input v-model.trim="ruleForm.vbeln" autocomplete="off" clearable></el-input>
          </el-form-item>
        </div>
        <div style="width: 50%;">
          <el-form-item label="出入库" prop="radio" :label-width="formLabelWidth1" required>
            <el-radio v-model="ruleForm.radio" label="O">发货</el-radio>
            <el-radio v-model="ruleForm.radio" label="I">收货</el-radio>
            <el-button @click="orderTask" type="primary">查询任务</el-button>
          </el-form-item>
        </div>
      </el-form>
      <div style=" width: 100%;
            border-top: 2px solid #ccc;
            "></div>
      <div style="
      font-size: calc(20vw * 100 / 1920);
      margin-bottom: 1.5%;
  ">队列表头</div>
      <div>
        <el-form :inline="true" class="demo-form-inline">

          <div style="display: flex; flex-wrap: nowrap;">
            <div style="width: 20%;">
              <el-form-item label="提单号" :label-width="formLabelWidth2">
                <input readonly="readonly" autocomplete="off" clearable></input>
              </el-form-item>
              <el-form-item label="承运商" :label-width="formLabelWidth2" prop="carrier">
                <input readonly="readonly" v-model.trim="orderData.carrier" autocomplete="off" clearable></input>
              </el-form-item>
            </div>
            <div style="width: 20%;">
              <el-form-item label="司机" :label-width="formLabelWidth2" prop="driver">
                <input readonly="readonly" v-model.trim="orderData.driver" autocomplete="off" clearable></input>
              </el-form-item>
              <el-form-item label="车牌号" :label-width="formLabelWidth2" prop="tuckNo">
                <input readonly="readonly" v-model.trim="orderData.tuckNo" autocomplete="off" clearable></input>
              </el-form-item>
            </div>
            <div style="width: 20%;">
              <el-form-item label="司机身份证号" label-width="96px" prop="driverCard">
                <input readonly="readonly" v-model.trim="orderData.driverCard" autocomplete="off" clearable></input>
              </el-form-item>
              <el-form-item label="司机电话号" prop="driverPhone">
                <input readonly="readonly" v-model.trim="orderData.driverPhone" autocomplete="off" clearable></input>
              </el-form-item>
            </div>
            <div style="width: 20%;">
              <el-form-item label="箱号" :label-width="formLabelWidth2" prop="tankBoxNo">
                <input readonly="readonly" v-model.trim="orderData.tankBoxNo" autocomplete="off" clearable></input>
              </el-form-item>
              <el-form-item label="铅封号" :label-width="formLabelWidth2" prop="tankBoxNo">
                <input readonly="readonly" v-model.trim="orderData.tankBoxNo" autocomplete="off" clearable></input>
              </el-form-item>
            </div>
            <div style="width: 20%;">
              <el-form-item label="LMS任务单号" label-width="100" prop="tankBoxNo">
                <input readonly="readonly" v-model.trim="orderData.lmsTaskNo" autocomplete="off" clearable></input>
              </el-form-item>
              <el-form-item label="要求到达时间" label-width="100" prop="tankBoxNo">
                <input readonly="readonly" v-model.trim="orderData.arriverTime" autocomplete="off" clearable></input>
              </el-form-item>
            </div>
          </div>
          <div>
            <el-form-item class="beizhu" label="备注" :label-width="formLabelWidth2">
              <el-input id="beizhu" type="textarea" autosize placeholder="备注" v-model.trim="text">
              </el-input>
            </el-form-item>
          </div>


        </el-form>

      </div>
      <div style=" width: 100%;
            border-top: 2px solid #ccc;
            margin: 13px 0;"></div>
      <div style="
      font-size: calc(20vw * 100 / 1920);
      margin-bottom: 2%;
  ">队列表体</div>
      <div>
        <el-table :data="tableData2" height="250" border style="width: 100%">
          <el-table-column label="行项目编号" prop="posnr">
          </el-table-column>
          <el-table-column label="前序单号" prop="vgbel">
          </el-table-column>
          <el-table-column prop="matnr" label="物料号">
          </el-table-column>
          <el-table-column prop="werks" label="工厂">
          </el-table-column>
          <el-table-column prop="lgort" label="发货库存地点">
          </el-table-column>
          <el-table-column prop="charg" label="批次">
          </el-table-column>
          <el-table-column prop="lfimg" label="交货数量">
          </el-table-column>
          <!-- <el-table-column
      prop="packageNum"
      label="件数"
      >
    </el-table-column> -->
          <el-table-column prop="packageNum" label="件数">
            <template scope="scope">
              <input class="inputColor" type="text" style="width: 100%;" v-model="scope.row.packageNum"
                onkeyup="value=value.match(/\d+\.?\d{0,3}/,'')"></input>
            </template>

          </el-table-column>

          <el-table-column prop="kcmeng" label="累计数量">
          </el-table-column>
          <el-table-column prop="vrkme" label="单位">
          </el-table-column>
          <el-table-column prop="arktx" label="物料名称" lable-width="200">
          </el-table-column>
          <el-table-column prop="tempb" label="温度标识">
          </el-table-column>
          <el-table-column prop="zzbqtp" label="标签">
          </el-table-column>
          <el-table-column prop="zztuopan" label="托盘">
          </el-table-column>
          <el-table-column prop="sepPaiHao" label="特殊牌号">
          </el-table-column>
        </el-table>

        <el-button slot="reference" style="height: 5%;" type="success" @click="receiveQueue">接收队列</el-button>

      </div>

    </el-dialog>

    <!-- 查看详情的弹出层 -->
    <el-dialog class="dialog-one" title="查看详情" :visible.sync="dialogVisible1" width="60%" height="70%" top="10%"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <el-table :data="tableData1" stripe style="width: 100%">
        <el-table-column prop="posnr" label="行项目号" width="auto">
        </el-table-column>
        <el-table-column prop="goodNo" label="原料号" width="auto">
        </el-table-column>
        <el-table-column prop="batchNo" label="批次号" width="auto">
        </el-table-column>
        <el-table-column prop="goodName" label="物料名称" width="350">
        </el-table-column>
        <el-table-column prop="taskNum" width="auto" label="任务数量">
        </el-table-column>

        <!-- <el-table-column
      prop="unassignedNum"
      width="auto"
      label="未完成数量">
    </el-table-column> -->
      </el-table>
    </el-dialog>

    <!-- 指货的弹出层 -->
    <el-dialog class="dialog-one" title="指货发货" :visible.sync="dialogVisible2" width="100%" height="100%" top="2%"
      :before-close="handleClose" :close-on-click-modal="false" :close-on-press-escape="true">
      <div style="display: flex;">
        <div>发货要求：</div>
        <div>{{ ckbz }}</div>
      </div>
      <el-table :data="tableData1" @row-click="getBatchNos" highlight-current-row style="width: 100%">
        <el-table-column prop="posnr" label="行项目号" width="auto">
        </el-table-column>
        <el-table-column prop="vgbel" label="前序订单号" width="auto">
        </el-table-column>
        <el-table-column prop="goodNo" label="原料号" width="auto">
        </el-table-column>
        <el-table-column prop="batchNo" label="批次号" width="auto">
        </el-table-column>
        <el-table-column prop="goodName" label="物料名称" width="350">
        </el-table-column>
        <el-table-column prop="taskNum" width="auto" label="任务数量">
        </el-table-column>
        <el-table-column width="auto" label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="handleSearch(scope.$index, scope.row)">查看指货</el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column
      prop="unassignedNum"
      width="auto"
      label="未完成数量">
    </el-table-column> -->
      </el-table>
      <div style="display: flex;margin-top: 10px;">
        <div style="margin-right: 20px;">
          <span>物料名称：</span><span>{{ goodName }}</span>
        </div>
        <div style="margin-right: 20px; display: flex;">
          <span style="vertical-align: top; width:35%;">批次号：</span>
          <el-input v-model.trim="batchNumber"></el-input> <!-- <span>{{ batchNumber }}</span> -->
        </div>
        <div style="margin-right: 20px; display: flex;">
          <span style="vertical-align: top; width:55%;">入库交货单号：</span>
          <el-input v-model.trim="rkjhdh"></el-input>
        </div>
        <div style="display: flex;width: 60%;">
          <span style="vertical-align: top; width:11%;">入库备注：</span>
          <el-input style="width: 150%;" type="textarea" :autosize="{ minRows: 1, maxRows: 300 }" placeholder="备注搜索"
            v-model.trim="remark">
          </el-input>
        </div>
        <div style="margin-left: 1%;">
          <el-button type="primary" @click="queryDetail" circle>查询</el-button>
        </div>
      </div>
      <el-table :cell-style="{ 'text-align': 'center' }" :header-cell-style="{ 'text-align': 'center' }"
        :data="tableData3" style="width: 100%">
        <!-- <el-table-column
        prop="wmsphysicsid"
        label="库存编号"
        width="auto">
      </el-table-column> -->
        <el-table-column prop="goodsmodel" label="商品名称" width="200%">
        </el-table-column>
        <el-table-column prop="cntrno" label="批次号" width="auto">
        </el-table-column>
        <el-table-column prop="mblno" label="入库交货单" width="auto">
        </el-table-column>
        <el-table-column prop="storageunitcount" label="库存吨数" width="auto">
        </el-table-column>
        <el-table-column prop="pkgs" label="件数" width="auto">
        </el-table-column>
        <el-table-column prop="wmsindate" label="入库时间" width="200%">
        </el-table-column>
        <el-table-column prop="remark_BOX" label="入库备注" width="700%">
        </el-table-column>
        <el-table-column prop="storehouse" label="仓库位置" width="auto">
        </el-table-column>

        <el-table-column prop="shippedTons" label="本次发货数量" width="180">
          <template slot-scope="scope">
            <el-input type="number" v-model.trim="scope.row.shippedTons" placeholder="请输入内容"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <el-button style="display:block;margin:10px auto" @click="submitDetailColumn" type="primary">提交</el-button>
    </el-dialog>
    <!-- 查看指货详情 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="指货详情"
      :visible.sync="dialogTableVisible">
      <el-table :data="tableData4">
        <el-table-column prop="vgbel" label="订单号"></el-table-column>
        <el-table-column prop="num" label="数量"></el-table-column>
        <el-table-column prop="batchNo" label="批次"></el-table-column>
        <el-table-column prop="rkjhdh" label="入库交货单号"></el-table-column>
      </el-table>
      <el-button type="danger" @click="deleteDetail" style="display:block;margin:0 auto; ">删除</el-button>
    </el-dialog>

    <PhotoDialog ref="PhotoDialog" :row="selectedRow"></PhotoDialog>
  </div>
</template>

<script>
import PhotoDialog from "@/view/childrenconponents/photodiago.vue";
import debounce from 'lodash.debounce';
import App from '../App'
import req from '@/utils/index.js';
import url from '@/config/taskdeliveryurl.js';
import url1 from '@/config/url2.js';
export default {
  name: 'taskDelivery',
  components: { App, PhotoDialog, },
  data() {
    return {
      selectedRow: null,//父传子photp
      arrayId: null,//id数组
      allZero: null,//判断数字是否为0
      zhxqrowId: '',//删除详情id
      dialogTableVisible: false,//弹框
      wantedNum: '',//需求数量
      rkjhdh: '',//入库交货单号
      ckbz: '',//出库备注
      rowId: '',
      vgbel: '',//前序订单号
      goodName: '',//物料名称
      batchNumber: '',//批次号'
      remark: '',//备注
      shipment: '',//发货数量
      jhdh: '',//交货单号
      div: '',//收发货
      text: '',//备注拼起来的串
      texts: [],

      ruleForm: {
        vbeln: '',//交货单号
        radio: 'O',//收货发货发货收货查询
      },
      numberValidateForm: {
        age: ''
      },

      //表头
      tableHeader: [],
      options: [],
      // 创建任务的表头
      pdaTask: {
        createMan: '',//创建人
        company: '',
      },
      orderData: {
      },//外向交货单查询
      orderItems: [],

      // 下发
      send: {
        id: '',
        status: ''
      },
      id: '',
      detailId: '',
      tableData1: [],
      tableData: [],
      tableData2: [],
      tableData3: [],//详情中的详情
      tableData4: [],
      // 查询任务列表条件
      queryParams: {
        taskNo: '',  //任务单号
        truckNo: '',  //车号
        truckMan: '', //司机
        interfaceNo: '', //第三方接口号
        startTime: '', //创建时间(开始)
        endTime: '', //创建时间(结束)
        blNo: '', //提单号
        flag: '全部',//选择

      },
      note: '',
      company: '',
      getGoods: [],//获取物料编码
      goodNo: '',//物料代码
      formLabelWidth: '120px',
      formLabelWidth1: '190PX',
      formLabelWidth2: '80PX',
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      // 
      // 数据存放
      list: [],
      currentPage: 1, // 当前页数
      pageSize: 21, // 每页显示的数据量
      total: 0, // 总数据量


      // 开始时间限制范围
      startNoTime: {
        disabledDate(date) {
          // 可选当天以及当天之前的日期
          return date.getTime() > Date.now()
        }
      },
      // 结束时间限制范围
      endNoTime: {
        disabledDate(date) {
          // 可选当天以及当天之前的日期
          return date.getTime() > Date.now()
        }
      },
    }
  },

  watch: {
    "queryParams.startTime": {
      handler(val) {
        if (val) {
          this.endNoTime = {
            disabledDate(time) {
              const time1 = new Date(val).getTime() - 8.64e7;
              return time.getTime() < time1 || time.getTime() > Date.now()
            }
          }
        } else {
          // 当清空时，进行一些默认的设置或恢复初始的禁用规则
          this.endNoTime = {
            disabledDate(time) {
              return time.getTime() > Date.now()
            }
          }
        }
      }
    },
    "queryParams.endTime": {
      handler(val) {
        if (val) {
          this.startNoTime = {
            disabledDate(time) {
              const time1 = new Date(val).getTime()
              return time.getTime() > time1 || time.getTime() > Date.now()
            }
          }
        } else {
          this.startNoTime = {
            disabledDate(time) {
              return time.getTime() > Date.now()
            }
          }
        }
      }
    },
  },

  created() {
    this.getGoodsIn();
    const value = localStorage.getItem('name');
    this.pdaTask.createMan = value;
    const value1 = localStorage.getItem('company');
    this.pdaTask.company = value1;
  },

  methods: {



    photo(index, row) {
      this.$refs.PhotoDialog.dialogFormVisible = true;
      this.selectedRow = row;
      this.$nextTick(() => {
        this.$refs.PhotoDialog.getCompetence();
      });

    },
    rowStyle() {
      return "text-align:center";
    },
    //合并下发
    merge() {
      if (this.allZero) {
        this.$confirm('将合并下发，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let URL13 = `${url1.mergePush}`;
          req.post(URL13, this.arrayId).then(res => {
            if (res.data.code == 200) {
              this.$nextTick(() => {
                this.submit();
              })
              this.$message({
                type: 'success',
                message: res.data.message
              });

            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              });
            }
          })
        })
      } else {
        this.$message({
          type: 'warning',
          message: '请选择未下发状态的任务单'
        });
      }
    },
    //选择表格
    handleSelectionChange(val) {
      this.arrayId = val.map(item => item.id)
      let allZero = val.every(item => item.taskFlag === 0);
      this.allZero = allZero;
      if (allZero) {

      } else {
        this.$message({
          type: 'warning',
          message: '请选择未下发状态的任务单'
        });
      }


    },
    //删除指货详情
    deleteDetail() {
      this.$confirm('将删除本行所有指货，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let URL12 = `${url1.deleteAssign}/${this.zhxqrowId}`;
        req.delete(URL12).then(res => {
          if (res.data.code == 200) {
            this.$message({
              type: 'success',
              message: '删除成功'
            });
            this.dialogTableVisible = false;
          } else {
            this.$message({
              type: 'success',
              message: res.data.message
            });
          }
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });


    },
    //查看指货详情
    handleSearch(index, row) {
      this.dialogTableVisible = true;
      let id = row.id;
      this.zhxqrowId = id;
      let URL11 = `${url1.getAssignResult}/${id}`
      req.get(URL11).then(res => {
        if (res.data.code == 200) {
          this.tableData4 = res.data.data;
          this.$message({
            type: 'success',
            message: '查看指货详情成功'
          });
        }
        else {
          this.$message({
            type: 'error',
            message: res.data.message
          });
        }

      })


    },
    //行提交详情
    submitDetailColumn() {
      if (this.tableData3.length == 0) {
        this.$message({
          type: 'error',
          message: '详情为空'
        });

      } else {

        let obj = [];
        for (let key in this.tableData3) {
          if (this.tableData3[key].shippedTons > this.tableData3[key].storageunitcount) {
            this.$message({
              type: 'error',
              message: '发货数量不能大于库存吨数'
            });
            return;
          }

          if (this.tableData3[key].shippedTons !== null && this.tableData3[key].shippedTons !== '') {
            let obj1 = {
              rowId: this.rowId,
              phyId: this.tableData3[key].wmsphysicsid,
              num: this.tableData3[key].shippedTons,
              vgbel: this.vgbel,
              batchNo: this.tableData3[key].cntrno,
              rkjhdh: this.tableData3[key].mblno,
            }
            obj.push(obj1);


          }



        }
        if (obj.length == 0) {
          this.$message.error('请填写发货数量');
          return;
        }
        let URL10 = `${url1.assignBatchs}`;
        // this.$nextTick(() => {
        req.post(URL10, obj).then(res => {
          if (res.data.code == 200) {
            this.$message({
              type: 'success',
              message: res.data.data
            });
          }
          // })
          this.tableData3 = [];
        })

      }


    },
    //指货-查询
    queryDetail() {
      let obj = {
        goodName: this.goodName,
        remark: this.remark,
        batchNo: this.batchNumber,
        wantedNum: this.wantedNum,
        jhdh: this.rkjhdh,
      }
      if (this.goodName == '') {
        this.$message({
          type: 'error',
          message: '请选择要查询的行'
        });
      } else {
        let URL9 = `${url1.getBatchNos}`
        req.post(URL9, obj).then(res => {
          if (res.data.code == 200) {
            this.tableData3 = res.data.data.rows;
            // let wmsphysicsid = this.tableData3.map(item => item.wmsphysicsid);
            this.$message({
              type: 'success',
              message: '获取批次详情成功'
            });
          }
          else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }

        })
      }


    },
    //获取批次里面详情
    getBatchNos(row, event, column) {
      let posnr = row.posnr;
      this.rowId = row.id;
      // let id = row.interId;
      // let sid = row.id;
      // let sno = row.posnr;
      this.goodName = row.goodName;
      this.wantedNum = row.taskNum
      let batchNo = row.batchNo;
      this.batchNumber = batchNo;
      this.vgbel = row.vgbel;




    },
    //指货按钮禁用
    disabled2(value, row) {
      let status = this.computedStatus(row.taskFlag)
      if (row.div == '发货' && status == '未下发') {
        return false;
      } else {
        return true;
      }
    },
    //签收
    handleSign(value, row) {
      // let esmtId = row.id;
      if (row.lmsTaskNo == null) {
        this.$confirm('LMS信息为空, 是否重新获取?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let URL9 = `${url1.getLmsInfo}/${row.id}`
          req.get(URL9).then(res => {
            if (res.data.code == 200) {
              this.$message({
                type: 'success',
                message: res.data.data
              });
              this.$nextTick(() => {
                this.submit();
              })
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      } else {
        let URL8 = `${url.sign}/${row.id}`
        req.post(URL8).then(res => {
          if (res.data.code == 200) {
            this.$message({
              type: 'success',
              message: res.data.data
            });
            this.$nextTick(() => {
              this.submit();
            })
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        })

      }
    },
    //筛选收发货
    filterTag(value, row) {
      return row.tag === value;
    },
    //清空弹出层
    resetForm() {
      this.ruleForm.vbeln = this.ruleForm.radio = '';
      this.tableData2 = [];
      this.tableData3 = [];
      this.orderData = [];
      this.orderItems = [];
      this.text = '';
      this.goodName = '',//物料名称
        this.batchNumber = '',//批次号'
        this.rkjhdh = ''//入库交货单号
      this.remark = ''
      this.wantedNum = ''
    },
    handleClose(done) {
      //清空
      this.resetForm();
      done();
    },
    remoteMethod(query) {
      // 自定义搜索方法
      // 在这里可以根据 label 或 value 包含查询关键字的项
      // 然后将符合条件的项返回给 el-select
      // 示例中使用了字符串的 includes 方法，你可以根据需要修改搜索逻辑
      this.options = this.options.filter(item =>
        item.label.includes(query) || item.value.includes(query)
      );
    },
    /* 获取选项列表 */

    add() {
      dialogVisible = false;

    },
    //接收队列
    receiveQueue() {
      if (this.ruleForm.radio == 'O') {
        this.div = '发货'
      } else if (this.ruleForm.radio == 'I') {
        this.div = '收货'
      }
      if (this.tableData2.length == 0) {
        this.$message({
          message: '请查询任务后再确认！',
          type: 'warning'
        });
      } else {
        this.$confirm('是否接收队列任务?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let obj = {
            whTaskesmt: {
              //字段没有
              blNo: this.ruleForm.vbeln,//交货单号
              createMan: this.pdaTask.createMan,
              company: this.pdaTask.company,
              truckNo: this.orderData.tuckNo,
              truckMan: this.orderData.driver,
              note: this.text,
              deliveryNo: this.orderData.vbeln,
              div: this.div,
              truckPhone: this.orderData.driverPhone,
              truckId: this.orderData.driverCard,
              tankBoxNo: this.orderData.tankBoxNo,
              tankFenghao: '',
              lmsTaskNo: this.orderData.lmsTaskNo,
              arriverTime: this.orderData.arriverTime,
            },
            whTaskEsmtDetailList: [
            ]
          }
          for (const key in this.tableData2) {
            obj.whTaskEsmtDetailList.push({
              goodNo: this.tableData2[key].matnr,
              taskNum: this.tableData2[key].lfimg,
              goodName: this.tableData2[key].arktx,
              batchNo: this.tableData2[key].charg,
              werks: this.tableData2[key].werks,
              tempFlag: this.tableData2[key].tempb,
              flag: this.tableData2[key].zzbqtp,
              tuopan: this.tableData2[key].zztuopan,
              specialPaihao: this.tableData2[key].sepPaiHao,
              vgbel: this.tableData2[key].vgbel,
              packageNum: this.tableData2[key].packageNum,
              posnr: this.tableData2[key].posnr,
              uecha: this.tableData2[key].uecha,
            })
          }
          let URL3 = `${url1.pushTask}`;
          req.post(URL3, obj).then(res => {
            if (res.data.code == 200) {
              this.$message({
                type: 'success',
                message: '接收成功!'
              });
              //清空
              this.resetForm();
              //  刷新队列
              this.$nextTick(() => {
                this.submit();
              })
            } else {
              this.$message({
                type: 'info',
                message: res.data.data
              });
            }

          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消！'
          });
        });

      }


    },
    rowStyle({ row, column, rowIndex, columnIndex }) {
      if (row.lmsTaskNo == null) {
        return 'background-color: #db5a6b; color:white;'
      }
    },
    // 重置
    reset() {
      this.queryParams.taskNo = '';
      this.queryParams.truckNo = '';
      this.queryParams.truckMan = '';
      this.queryParams.interfaceNo = '';
      this.queryParams.blNo = '';
      this.queryParams.endTime = '';
      this.queryParams.startTime = '';

    },
    submit() {
      this.getData(1);
    },
    // 页数发生改变时
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData(this.currentPage);
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData(this.currentPage)

    },
    getGoodsIn() {
      // const URL1 = `${url.getGoods}?condition=${this.goodNo}`;
      // req.get(URL1).then(res=>{
      //   if(res.data.code === 200){
      //     this.getGoods = res.data.data;
      //   }
      // })
      const value = localStorage.getItem('company');
      this.company = value;


    },
    // 查询任务列表
    getData(page) {
      this.currentPage = page;
      let URL = `${url.findTask}/${this.currentPage}/${this.pageSize}?company=${this.company}`;
      this.queryParams.endTime = this.queryParams.endTime + '23:59:59';
      req.post(URL, this.queryParams).then(res => {
        if (res.data.code === 200) {
          this.total = res.data.data.total;
          // this.total = 24
          this.list = res.data.data.records;
        }
      })
      this.queryParams.endTime = this.queryParams.endTime.slice(0, -8);
    },
    // 添加任务
    addTask() {
      let URL2 = `${url.pushTask}`;
      req.post(URL2, this.pdaTask)
    },
    // 下发
    sendStatus() {
      let URL = `${url.changeStatus}/${this.send.id}/${this.send.status}`;
      req.post(URL).then(res => {
        if (res.data.code === 200) {
          this.$message({
            type: 'success',
            message: '更改成功！',
          });
          this.$nextTick(() => {
            this.submit();
          })
        } else {
          this.$message({
            type: 'error',
            message: res.data.message,
          });

        }
      })
    },
    handleSend(index, row) {
      const throttledClick = debounce(() => {
        this.send.id = row.id;
        //下发为1
        this.send.status = 1;
        this.sendStatus();
        // this.submit();  
      }, 1500);
      // this.getData();
      throttledClick();

    },
    disabled(row) {
      if (row === 0) {
        return false;
      } else {
        return true;
      }
    },
    // 手动终止
    handleStop(index, row) {
      const throttledClick = debounce(() => {
        this.send.id = row.id;
        //状态改为3手动终止
        this.send.status = 3;
        this.sendStatus();
      }, 1500);
      throttledClick();


    },
    disabled1(row) {
      if (row === 1) {
        return false;
      } else {
        return true;
      }
    },
    //计算状态
    computedStatus(value) {
      switch (value) {
        case 0:
          return '未下发';
        case 1:
          return '已下发';
        case 2:
          return '已签收';
        case 3:
          return '已终止';
        default:
          return '未知';
      }
    },
    handleDelete(index, row) {
      this.id = row.id;
      this.$confirm('此操作将永久删除该批次记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let URL5 = `${url.deleteTask}/${row.id}`;
        req.delete(URL5).then(res => {
          if (res.data.code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功！',
            });
            this.submit();
          } else {
            this.$message({
              type: 'error',
              message: res.data.message,
            });

          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //重置弹出框
    resetAll() {
      // this.pdaTask.blNo = '';
      // this.pdaTask.truckNo ='';
      // this.pdaTask.truckMan ='';
      // this.pdaTask.note ='';
      // this.pdaTask.interfaceNo ='';
      this.tableData = [];
    },
    //指货
    handleBatch(index, row) {
      // this.rowId = row.id;
      this.detailId = row.id;
      this.jhdh = row.deliveryNo;
      let URL6 = `${url1.getDetailById}?id=${this.detailId}`;
      req.get(URL6).then(res => {
        if (res.data.code === 200) {
          this.tableData1 = res.data.data;

          this.dialogVisible2 = true;
        } else {
          this.$message({
            type: 'error',
            message: res.data.message,
          });

        }
      })
      let URL10 = `${url1.getCkNote}/${this.detailId}`;
      req.get(URL10).then(res => {
        if (res.data.code === 200) {
          this.ckbz = res.data.data;
        } else {
          this.$message({
            type: 'error',
            message: res.data.message,
          });

        }
      })
    },
    handleDetail(index, row) {
      this.detailId = row.id;
      // this.jhdh = row.deliveryNo;
      let URL6 = `${url1.getDetailById}?id=${this.detailId}`;
      req.get(URL6).then(res => {
        if (res.data.code === 200) {
          this.tableData1 = res.data.data;
          this.dialogVisible1 = true;
        } else {
          this.$message({
            type: 'error',
            message: res.data.message,
          });

        }
      })
    },
    //弹出框查询任务
    orderTask() {
      if (this.ruleForm.vbeln == '') {
        this.$message({
          type: 'error',
          message: '请输入交货单号',
        });
      } else {
        let URL7 = `${url1.odQuery}/${this.ruleForm.radio}/${this.ruleForm.vbeln}`;
        req.post(URL7).then(res => {
          if (res.data.code === 200) {
            this.$message({
              type: 'success',
              message: res.data.message,
            });
            this.orderData = res.data.data;
            this.orderItems = res.data.data.items[0];
            const result = this.orderData.texts.reduce((accumulator, obj, index, array) => {
              for (const key in obj) {
                if (index === array.length - 1) {
                  accumulator.push(obj[key] + ":");
                } else {
                  accumulator.push(obj[key]);
                }
              }
              return accumulator;
            }, []);
            let text = result.join('');
            this.text = text.slice(0, -1)
            this.tableData2 = res.data.data.items;
            const packageNum = this.tableData2.packageNum;
            const decimalRegex = /\.\d+/;
            if (packageNum && decimalRegex.test(packageNum)) {
              // 使用 Element UI 的消息提示
              let timer = setTimeout(() => {
                this.$message({
                  type: 'error',
                  message: '系统计算出件数为小数，请核对!',
                });
              }, 1000);

            }


          } else {
            this.$message({
              type: 'error',
              message: res.data.message,
            });
          }
        })
      }




    },
  }
};
</script>

<style lang="less" scoped>
// /deep/ 
/deep/  .el-table .el-table__cell {
    padding: 0 !important;
}
/deep/ .el-form-item__label{
  white-space: nowrap;
}
/deep/ .el-table{
  margin-top:3px !important;
}
// /deep/ .el-table th.el-table__cell>.cell{
//   width: 116%;
// }
/deep/ .el-table th > .cell {
    white-space: nowrap;
    width: fit-content;
    padding: 0 !important;

}
/deep/.el-pagination{
  margin-top: 0 !important;
  padding: 0 !important;
}
/deep/ .el-form-item{
  margin-bottom: 0;
  width:100% !important;
  display: flex;
  align-items: center; /* 垂直居中对齐 */
  justify-content: flex-start; 
}
/deep/.el-form-item.el-input {
  flex-grow: 1;
  max-width: calc(100% - 100px);
}
/deep/  .el-input__inner {
  height:35px;
  width:100%;
}
.el-tag{
  padding: 0;
  width: calc(60vw * 100 / 1920);
}
/deep/ .btncl .el-button {
  // flex: 1;
  width: calc(60vw * 100 / 1920);
  padding: 6.5px 3px;
  font-size: calc(14vw * 100 / 1920);
  margin-left: 4px
}
/deep/ .el-table .cell{
  padding-left: 0;
  padding-right: 0;
}
/deep/ .el-table .el-table__cell {
  padding: 4.1px 1px;
}

/deep/ .el-table__body tr.current-row>td {
  background-color: #BBBBBB !important;
  color: #fff;
}

.container {
  overflow-x: hidden;
  position: relative;
}

#dialog1-id /deep/ .el-dialog {
  position: absolute;
  top: -15%;
  left: 15%;
  height: 100vh;
  width: 60vw;
  overflow: scroll;


}

.el-dialog {
  position: relative;
}

// & /deep/ .dialog-one{
//   height: auto;
// }

& /deep/ .el-dialog__body {
  padding: 5px 20px;
}

& /deep/ .el-select {
  width: 100%;
}

.icon1 {
  font-size: 26px;
  text-align: center;
}

.el-form-item input {
  border: 1px solid #d2d2d2;
  height: 25px;
}

.el-form-item input:focus {
  outline: none;
}

/deep/ #beizhu {
  width: 630%;
}

.inputColor {
  BACKGROUND-COLOR: transparent;
  border: none;
  width: 100%;
}
</style>